import React from 'react';
import { Field } from 'redux-form';
import * as _ from 'lodash';

import { EditServedItemFieldEnum as Fields } from 'Common/FieldEnum';
import { SelectField, InputField, Checkbox } from 'Common/SemanticWrapper';
import { GridContextMenu } from 'Components/app/contextmenu/ContextMenuManager';
import { formatDecimal } from 'Common/FormHelper';

export const OverflowableTableProps = {
  className: 'react-table-allow-overflow grid--flex-row-height',
  getTbodyProps: (state, rowInfo, column) => {
    return {
      className: 'allow-overflow',
      style: {
        minWidth: '500px',
      },
    };
  },
  getTableProps: (state, rowInfo, column) => {
    return {
      className: 'allow-overflow',
      style: {
        minWidth: '500px',
      },
    };
  },
};

export const PriceFields = {
  ItemId: 'ItemId',
  GradeId: 'GradeId',
  FreePrice: 'FreePrice',
  ReducedPrice: 'ReducedPrice',
  StudentPrice: 'StudentPrice',
  TeacherPrice: 'TeacherPrice',
  AdultPrice: 'AdultPrice',
  StaffPrice: 'SFSPrice',
  CateredPrice: 'CateredPrice',
  ProhibitedFlag: 'ProhibitedFlag',
  StateReimbursable: 'StateReimbursable',
};

export const MAX_PRICE = 999.99;

export const ConvertAmountFields = {
  Id: 'Id',
  GradeId: 'GradeId',
  ItemId: 'ItemId',
  ConvertAmount: 'ConvertAmount',
};

export const DefaultPrice = {
  [PriceFields.ItemId]: '',
  [PriceFields.GradeId]: '00',
  [PriceFields.FreePrice]: '0.00',
  [PriceFields.ReducedPrice]: '0.00',
  [PriceFields.StudentPrice]: '0.00',
  [PriceFields.TeacherPrice]: '0.00',
  [PriceFields.AdultPrice]: '0.00',
  [PriceFields.StaffPrice]: '0.00',
  [PriceFields.CateredPrice]: '0.00',
  [PriceFields.ProhibitedFlag]: {
    Adult: false,
    Catered: false,
    Free: false,
    Reduced: false,
    SFS: false,
    Student: false,
    Teacher: false,
  },
  [PriceFields.StateReimbursable]: false,
};

export const DefaultConvertAmount = {
  [ConvertAmountFields.Id]: null,
  [ConvertAmountFields.GradeId]: null,
  [ConvertAmountFields.ItemId]: null,
  [ConvertAmountFields.ConvertAmount]: 0.5,
};

export const NutritionCodeOptions = (NutritionCodes, MealType) =>
  NutritionCodes.map(nc => ({
    text: `${nc.Code} ${nc.Description ? ` (${nc.Description})` : ''}`,
    value: nc.Code,
    disabled: !nc.ValidMealTypes.includes(MealType),
  }));

export const ItemCategoryOptions = ItemCategories =>
  [{ text: 'None', value: '' }].concat(
    ItemCategories.map(ic => ({
      text: ic.Description,
      value: ic.Id,
    }))
  );

export const AlternateItemOptions = AlternateItems =>
  [{ text: 'None', value: '' }].concat(
    AlternateItems.map(ai => ({
      text: `${ai.Id} ${ai.Description ? ` (${ai.Description})` : ''}`,
      value: ai.Id,
    }))
  );

export const ItemIdLetterOptions = [
  {
    text: 'B',
    value: 'B',
  },
  {
    text: 'L',
    value: 'L',
  },
  {
    text: 'O',
    value: 'O',
  },
  {
    text: 'S',
    value: 'S',
  },
];

export const priceFormat = value => {
  return formatDecimal(2)(parseFloat(value) > MAX_PRICE ? MAX_PRICE : value);
};

export const ConvertAmountColumns = (
  grades,
  convertAmountOptions,
  selectedAmounts,
  isReadOnly
) => [
  {
    Header: 'Grade',
    Cell: row => {
      var gradeOptions = grades
        .map(grade => ({
          text: grade.Id,
          value: grade.Id,
        }))
        .filter(
          grade =>
            grade.value !== '00' &&
            (selectedAmounts.findIndex(
              g => g[ConvertAmountFields.GradeId] === grade.value
            ) === -1 ||
              row.original[ConvertAmountFields.GradeId] === grade.value)
        );
      return (
        <Field
          label={false}
          component={SelectField}
          fluid
          className={'shorter'}
          options={gradeOptions}
          name={`${Fields.ConvertAmounts}[${row.index}].${
            ConvertAmountFields.GradeId
          }`}
          disabled={isReadOnly}
        />
      );
    },
  },
  {
    Header: 'Convert Amount',
    Cell: row => (
      <Field
        label={false}
        disabled
        fluid
        component={InputField}
        name={`${Fields.ConvertAmounts}[${row.index}].${
          ConvertAmountFields.ConvertAmount
        }`}
        hideError
      />
    ),
  },
  {
    Header: '',
    resizable: false,
    width: 50,
    sortable: false,
    Cell: gridProps => {
      return GridContextMenu({
        gridProps,
        options: convertAmountOptions(gridProps),
      });
    },
  },
];

export const ProhibitedFlagColumns = [
  {
    Header: 'Status',
    accessor: 'status',
    Cell: row =>
      row.original.status === 'Student' ? 'Paid' : row.original.status,
  },
  {
    Header: 'Prohibited',
    style: {
      textAlign: 'center',
    },
    Cell: row => (
      <Field
        label={false}
        component={Checkbox}
        name={`${Fields.Prices}[${row.original.index}].${
          PriceFields.ProhibitedFlag
        }[${row.original.status}]`}
        disabled={row.original.disabled}
      />
    ),
  },
];

export function ConvertAmountOptions(row) {
  const { change, formValues } = this.props;
  return [
    {
      icon: 'cancel',
      text: 'Delete',
      handler: () => {
        const deletedAmounts = _.cloneDeep(formValues[Fields.ConvertAmounts]);
        deletedAmounts.splice(row.index, 1);
        change(Fields.ConvertAmounts, deletedAmounts);
      },
    },
  ];
}



// WEBPACK FOOTER //
// ./src/pages/serveditemsetup/helpers/EditItemHelpers.js